const faqData = [
  {
    q: '黑料大赛是什么？靠谱吗？',
    a: '黑料大赛是一个专注于娱乐八卦资讯聚合的平台，实时追踪网红撕逼、明星丑闻等热点事件。我们坚持从公开渠道收集信息，标注来源，不做主观臆断。所有内容均来自社交媒体公开帖文、媒体报道及网友投稿，供吃瓜群众参考交流。',
  },
  {
    q: '如何第一时间获取最新八卦？',
    a: '你可以通过首页邮箱订阅功能接收每日快讯推送，也可以关注我们的社交媒体账号。本站首页实时更新，建议每天刷新查看最新动态。此外，#updates 快讯区按时间倒序排列，方便你快速浏览最新内容。',
  },
  {
    q: '投稿爆料会被泄露身份吗？',
    a: '我们郑重承诺：所有爆料投稿均采用匿名处理，投稿人信息不会以任何形式对外公开。我们使用加密传输保护数据安全，编辑团队审核后会隐去可能暴露身份的所有细节后再发布。',
  },
  {
    q: '网上传的那些八卦都是真的吗？',
    a: '黑料大赛汇总的是网络上流传的八卦信息和公开报道，我们会在每篇文章中注明信息来源。对于未经证实的传闻，我们会标注"网络热传"或"待核实"。建议读者理性吃瓜，自行判断信息的可信度，切勿将传闻当作事实传播。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">吃瓜必读</h2>
          <p className="mt-2 text-sm text-foreground-600">关于黑料大赛，你可能想知道的一切</p>
        </div>

        <div className="flex flex-col gap-4">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-2xl border border-background-200/70 p-6 hover:border-accent-200/50 transition-colors duration-200">
              <h3 className="text-base font-heading font-bold text-foreground-900 flex items-start gap-3">
                <span className="text-accent-500 flex-shrink-0 mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}